import { render, staticRenderFns } from "./explore.vue?vue&type=template&id=7c8ea790&"
import script from "./explore.vue?vue&type=script&lang=ts&"
export * from "./explore.vue?vue&type=script&lang=ts&"
import style0 from "./explore.vue?vue&type=style&index=0&id=7c8ea790&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSearchBar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonSearchBar.vue').default,CommonCommunity: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonCommunity.vue').default,CommunityCardGrid: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/community/CommunityCardGrid.vue').default,CommonTextBlock: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonTextBlock.vue').default})
